module.exports = __webpack_public_path__ + "media/images/lb/389-2161ab59113b7e23219dbdb0edc51343.svg";